import React from 'react';
import { ErrorMessage, FastField } from 'formik';
import Proptypes from 'prop-types';
import StyledRadioButton from '../radio/StyledRadioButton';
import { formErrorMessage } from './FormErrorMessage';

const FormikRadio = ({
  name,
  options,
  disabled,
  radioLabelClassName = '',
  className = '',
}) => {
  return (
    <FastField name={name}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <div
            className={`d-flex align-items-center flex-wrap py-1 py-lg-2 ${className}`}
          >
            {options?.map((option, index) => (
              <StyledRadioButton
                label={option.label}
                id={`${name}-${index}-${option.label}`}
                value={value === option.value}
                disabled={disabled}
                onChange={() => {
                  setFieldValue(name, option.value);
                }}
                key={`radio-${name}-${index}-${option.label}`}
                name={name}
                radioLabelClassName={radioLabelClassName}
              />
            ))}
          </div>
          <ErrorMessage name={name} render={formErrorMessage} />
        </>
      )}
    </FastField>
  );
};
FormikRadio.propTypes = {
  name: Proptypes.string.isRequired,
  options: Proptypes.array.isRequired,
};

export default React.memo(FormikRadio);
